module.exports = __webpack_public_path__ + "static/media/oreilly.210bb28e.png";